import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BuildingIcon, BriefcaseIcon, LandmarkIcon, StoreIcon, FactoryIcon } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    quote: 'Pasamos de perder el 60% de nuestros prospectos a agendar 3 veces más citas en el primer mes.',
    name: 'Carlos M.',
    role: 'Agencia de Marketing'
  }, {
    quote: 'CONECKTA se pagó solo en la primera semana. No puedo creer que hacía todo esto manualmente.',
    name: 'Laura G.',
    role: 'Bienes Raíces'
  }, {
    quote: 'Solo la velocidad de respuesta cambió todo para mi negocio. Mis clientes están impresionados.',
    name: 'Roberto V.',
    role: 'Servicios Locales'
  }];
  const logos = [{
    icon: BuildingIcon,
    name: 'EmpresaCorp'
  }, {
    icon: BriefcaseIcon,
    name: 'Consultores'
  }, {
    icon: LandmarkIcon,
    name: 'CapitalGroup'
  }, {
    icon: StoreIcon,
    name: 'LocalPro'
  }, {
    icon: FactoryIcon,
    name: 'Industrias'
  }];
  return <section className="py-24 bg-navy relative overflow-hidden" data-id="element-105">
      <div className="max-w-7xl mx-auto px-6" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-108">
            Empresarios Como Tú Ya Confían en CONECKTA
          </h2>

          {/* Logos Row */}
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-50 grayscale hover:grayscale-0 transition-all duration-500 mb-20" data-id="element-109">
            {logos.map((logo, index) => <div key={index} className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-110">
                <logo.icon className="w-6 h-6" data-id="element-111" />
                <span className="font-bold text-lg tracking-tight" data-id="element-112">
                  {logo.name}
                </span>
              </div>)}
          </div>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-113">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="card-hover p-8 flex flex-col justify-between" data-id="element-114">
              <div data-id="element-115">
                <div className="flex gap-1 mb-6" data-id="element-116">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-500 text-yellow-500" data-id="element-117" />)}
                </div>
                <p className="text-gray-300 italic text-lg mb-8 leading-relaxed" data-id="element-118">
                  "{testimonial.quote}"
                </p>
              </div>
              <div data-id="element-119">
                <div className="font-bold text-white" data-id="element-120">{testimonial.name}</div>
                <div className="text-sm text-gray-500" data-id="element-121">{testimonial.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}